export default __webpack_public_path__ + "static/media/technology_robot.bb920431.jpg";